import Menu from './Menu';

export default function Layout({ children }: { children: React.ReactNode }) {
    return (
        <div className=''>
            <div className='flex justify-end'><Menu /></div>
            <div className='flex justify-center'>
                {children}
            </div>
        </div>
    )
}